import React from "react";
import educate from '../../Content/Image/icon-education.svg'
import experience from '../../Content/Image/icon-experience.svg'

export default function CV() {
  return (
    <div>
      <div className="main-articles ">
        <div className="col-12">
          <h2 className="title title--h1 first-title title__separate fw-9">
            رزومه
          </h2>
          <div className="row mt-5">
            <div className="col-12">
              <h4 className="title title--h3 text-white fw-9">
                <img
                  className="title-icon"
                  src={educate}
                  alt=""
                />{" "}
                تحصیلات
              </h4>
              <div className="timeline">
                <article className="timeline__item">
                  <h5 className="title title--h5 timeline__title text-white">
                    دانشگاه قم
                  </h5>
                  <p className="timeline__description">
                    کارشناسی پیوسته رشته علوم کامپیتر
                  </p>
                </article>
                <article className="timeline__item">
                  <h5 className="title title--h5 timeline__title text-white">
                    دانشگاه علوم تحقیقات
                  </h5>
                  <p className="timeline__description">
                    کارشناسی ارشد - هوش مصنوعی
                  </p>
                </article>
              </div>
            </div>
            <div className="col-12 mt-5">
              <h4 className="title title--h3 fw-9 text-white">
                <img
                  className="title-icon"
                  src={experience}
                  alt=""
                />{" "}
                تجربه
              </h4>
              <div className="timeline mt-3">
                <article className="timeline__item">
                  <h5 className="title title--h5 timeline__title text-white">
                    طراحی، توسعه و کدنویسی وب
                  </h5>
                  <span className="timeline__period text-xsmall">
                    1398 - حاضر
                  </span>
                  <p className="timeline__description">
                    طراحی و کدنویسی وب به صورت فریلنس همچنین همکاری با شرکت های
                    معتبر مسلط به امور برنامه نویسی منطق برنامه نویسی و کدزنی
                    بهینه
                  </p>
                </article>

                <article className="timeline__item">
                  <h5 className="title title--h5 timeline__title text-white">
                    داده کاوی
                  </h5>
                  <span className="timeline__period text-xsmall">
                    1402 - حاضر
                  </span>
                  <p className="timeline__description">
                    انجام مینی پروژه های داده کاوی آشنا به اصول اولیه و همچنین
                    مفاهیم داده کاوی آشنا به کتابخانه های داده کاوی همچون
                    sk-learn ، Pandas و ... علاقه مند به هوش مصنوعی و ماشین
                    لرنینگ
                  </p>
                </article>

                <article className="timeline__item">
                  <h5 className="title title--h5 timeline__title text-white">
                    عکاسی، فیلمبرداری{" "}
                  </h5>
                  <span className="timeline__period text-xsmall">
                    1399 - حاضر
                  </span>
                  <p className="timeline__description">
                    عکاسی و فیلمبرداری انواع زمینه های کاری همچون مدلینگ ، صنعتی
                    و ...
                  </p>
                </article>
                <article className="timeline__item">
                  <h5 className="title title--h5 timeline__title text-white">
                    اپراتور اجرای Stream Live{" "}
                  </h5>
                  <span className="timeline__period text-xsmall">
                    1399 - حاضر
                  </span>
                  <p className="timeline__description">
                    Setup و نصب دستگاه های اجرای لایو در پلتفرم های متفاوت
                    کارگردانی و سوییچ تصاویر
                  </p>
                </article>
              </div>
            </div>
          </div>

          <div className="col-12 mt-5">
            <h3 className="title title--h3 fw-9 text-white">مهارت های من</h3>
            <div className="box box__border py-4 px-3 mt-3">
              <div className="progress">
                <div
                  className="progress-bar"
                  role="progressbar"
                  aria-valuenow="80"
                  aria-valuemin="0"
                  aria-valuemax="100"
                //   style="width:95%"
                  style={{ width: 95 + '%', zIndex: 2 }}
                >
                  <div className="progress-text">
                    <span>HTML</span>
                    <span>95%</span>
                  </div>
                </div>
              </div>
              <div className="progress">
                <div
                  className="progress-bar"
                  role="progressbar"
                  aria-valuenow="80"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style={{ width: 95 + '%', zIndex: 2 }}
                >
                  <div className="progress-text">
                    <span>CSS</span>
                    <span>95%</span>
                  </div>
                </div>
              </div>
              <div className="progress">
                <div
                  className="progress-bar"
                  role="progressbar"
                  aria-valuenow="80"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style={{ width: 90 +'%', zIndex: 2 }}
                >
                  <div className="progress-text">
                    <span>BootStrap</span>
                    <span>90%</span>
                  </div>
                </div>
              </div>
              <div className="progress">
                <div
                  className="progress-bar"
                  role="progressbar"
                  aria-valuenow="80"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style={{ width: 90 + '%', zIndex: 2 }}
                >
                  <div className="progress-text">
                    <span>JavaScript</span>
                    <span>90%</span>
                  </div>
                </div>
              </div>
              <div className="progress">
                <div
                  className="progress-bar"
                  role="progressbar"
                  aria-valuenow="80"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style={{ width: 70 + '%', zIndex: 2 }}
                >
                  <div className="progress-text">
                    <span>React</span>
                    <span>70%</span>
                  </div>
                </div>
              </div>
              <div className="progress">
                <div
                  className="progress-bar"
                  role="progressbar"
                  aria-valuenow="80"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style={{ width: 80 + '%', zIndex: 2 }}
                >
                  <div className="progress-text">
                    <span>JQuery</span>
                    <span>80%</span>
                  </div>
                </div>
              </div>
              <div className="progress">
                <div
                  className="progress-bar"
                  role="progressbar"
                  aria-valuenow="80"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style={{ width: 80 + '%', zIndex: 2 }}
                >
                  <div className="progress-text">
                    <span>Ajax</span>
                    <span>80%</span>
                  </div>
                </div>
              </div>
              <div className="progress">
                <div
                  className="progress-bar"
                  role="progressbar"
                  aria-valuenow="80"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style={{ width: 70 + '%', zIndex: 2 }}
                >
                  <div className="progress-text">
                    <span>Tailwind</span>
                    <span>70%</span>
                  </div>
                </div>
              </div>
              <div className="progress">
                <div
                  className="progress-bar"
                  role="progressbar"
                  aria-valuenow="80"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style={{ width: 50 + '%', zIndex: 2 }}
                >
                  <div className="progress-text">
                    <span>Python</span>
                    <span>50%</span>
                  </div>
                </div>
              </div>

              <div className="progress">
                <div
                  className="progress-bar"
                  role="progressbar"
                  aria-valuenow="80"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style={{ width: 60 + '%', zIndex: 2 }}
                >
                  <div className="progress-text">
                    <span>C#</span>
                    <span>60%</span>
                  </div>
                </div>
              </div>
              <div className="progress">
                <div
                  className="progress-bar"
                  role="progressbar"
                  aria-valuenow="80"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style={{ width: 85 + '%', zIndex: 2 }}
                >
                  <div className="progress-text">
                    <span>Responsive Design</span>
                    <span>85%</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="box box__border py-4 px-3 mt-3">
              <h3 className="title title--h3 fw-9 text-white">آشنا به</h3>
              <div className="d-flex flex-wrap align-items-center">
                <span className="tags">Asp.Net Mvc & Asp.net Core</span>
                <span className="tags">SQL</span>
                <span className="tags">Git/Github</span>
                <span className="tags">Azure</span>
                <span className="tags">Plesk</span>
                <span className="tags">Sass</span>
                <span className="tags">UI/UX </span>
                <span className="tags">Redux </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
